/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.lendMaster.detail.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
